// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthTitle_container__8ILiY","mobile":"AuthTitle_mobile__EhKBY","desctop":"AuthTitle_desctop__H6zbs"};